import { CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import PageContainer from "@/pages/containers/page-container";

const SurveySkeleton = () => {
  return (
    <PageContainer title="Survey Form">
      <div className="space-y-4 p-4">
        {/* Header */}
        <Skeleton className="h-6 w-1/3" />

        {/* Section 1 */}
        <div className="space-y-2 rounded-md border p-4">
          <Skeleton className="h-6 w-1/4" />
          <Skeleton className="h-10 w-full" />
        </div>

        {/* Section 2 (list with bullets) */}
        <CardContent className="space-y-2 rounded-md border p-4">
          <Skeleton className="h-6 w-1/4" />
          {[...Array(4)].map((_, i) => (
            <div key={i} className="flex items-center space-x-2">
              <Skeleton className="size-3 rounded-full" />
              <Skeleton className="h-4 w-1/2" />
              {i === 3 && <Skeleton className="h-4 w-1/3" />}
            </div>
          ))}
        </CardContent>
        {/* Section 3 (checkbox-like) */}
        <CardContent className="space-y-2 rounded-md border p-4">
          <Skeleton className="h-6 w-1/4" />
          {[...Array(4)].map((_, i) => (
            <div key={i} className="flex items-center space-x-2">
              {/* Square checkbox skeleton */}
              <Skeleton className="size-4" />
              <Skeleton className="h-4 w-1/2" />
              {i === 3 && <Skeleton className="h-4 w-1/3" />}
            </div>
          ))}
        </CardContent>

        {/* Section 4 (footer with dots) */}
        <CardContent className="space-y-2 rounded-md border p-4">
          <Skeleton className="h-6 w-1/4" />
          <div className="flex space-x-6 pt-2">
            {[...Array(5)].map((_, i) => (
              <Skeleton key={i} className="size-4 rounded-full" />
            ))}
          </div>
        </CardContent>
      </div>
    </PageContainer>
  );
};

export default SurveySkeleton;
